import d from "./index2.js";
import { resolveComponent as o, openBlock as s, createElementBlock as g, normalizeClass as p, createVNode as n, createElementVNode as a, renderSlot as m, createBlock as t, createCommentVNode as i } from "vue";
import "./index3.js";
import "./index4.js";
import S from "../../../../_virtual/index.js";
const h = { class: "flex-wrapper" }, b = { class: "body-content" };
function v(e, y, C, E, _, w) {
  const r = o("external-resources"), l = o("Banner"), c = o("Footer"), f = o("SignIn"), u = o("ExpiredSessionDialog");
  return s(), g("div", {
    class: p(["base-application", e.affiliateClass])
  }, [
    n(r, { values: e.headerExternalResources }, null, 8, ["values"]),
    a("div", h, [
      n(l, {
        config: e.config,
        location: e.location,
        csr: e.csr,
        user: e.user,
        bannerStyle: e.banner,
        menuCategories: e.menuCategories,
        "show-search": e.config.showSearch !== !1
      }, null, 8, ["config", "location", "csr", "user", "bannerStyle", "menuCategories", "show-search"]),
      a("div", b, [
        m(e.$slots, "default", {}, void 0, !0)
      ]),
      e.footerEnabled && e.config.showFooter !== !1 ? (s(), t(c, {
        key: 0,
        footerStyle: e.footer,
        config: e.config
      }, null, 8, ["footerStyle", "config"])) : i("", !0)
    ]),
    n(r, { values: e.footerExternalResources }, null, 8, ["values"]),
    e.showDialog ? (s(), t(f, {
      key: 0,
      class: "sign-in-dialog",
      disableSendingSignInRequestsToOtherHosts: e.disableSendingSignInRequestsToOtherHosts,
      config: e.config
    }, null, 8, ["disableSendingSignInRequestsToOtherHosts", "config"])) : i("", !0),
    n(u)
  ], 2);
}
const q = /* @__PURE__ */ S(d, [["render", v], ["__scopeId", "data-v-f144aae2"]]);
export {
  q as default
};
//# sourceMappingURL=index.js.map
